const body = document.body;
window.addEventListener('scroll', () => {
  body.classList.toggle('hide-announcement', window.scrollY <= 40);
});

// FIX: guard — element may not exist if header menu setting is blank
if (document.querySelector(".menu-close-icon")) {
  document.querySelector(".menu-close-icon").addEventListener("click", function () {
    document.querySelector(".header__icon--menu").click();
  })
}

// FIX: guard
if (document.querySelector(".header__icon--menu")) {
  document.querySelector(".header__icon--menu").addEventListener("click", function () {
    document.querySelector("body").classList.toggle("overflow-hidden");
    document.querySelector("#MainContent").classList.toggle("overflow-hidden");
  })
}

if (document.querySelector("[href='#open-chat']")) {
  document.querySelectorAll("[href='#open-chat']").forEach(function (box) {
    box.addEventListener("click", function (e) {
      e.preventDefault();
      GorgiasChat.open();
    })
  })
}

function closeajaxcart() {
  document.querySelector(".ajax-success-modal").style.display = 'none';
}

function openajaxcart() {
  // document.querySelector(".ajax-success-modal").style.display = 'block';
  fetchCart();
  closecart();
  // setTimeout(() => {
  //   closeajaxcart()
  // }, 2000);
}

function changemaster() {
  var master = document.querySelectorAll("#masterselect option");

  var selected = document.querySelectorAll(".product-value.active");
  var variantname = '';

  for (let i = 0; i < selected.length; i++) {
    const element = selected[i].getAttribute("data-title");
    if (i == selected.length - 1) {
      variantname = variantname + element;
    }
    else {
      variantname = variantname + element + ' / ';
    }
  }

  var choosen = false;
  var available = false;
  var id = "";
  var price = "";
  var compareprice = "";
  var sku = '';
  for (let j = 0; j < master.length; j++) {
    const element = master[j].getAttribute("data-index");
    if (element == variantname) {
      id = master[j].getAttribute("value");
      document.querySelector("#masterselect").value = id;
      price = master[j].getAttribute("data-price");
      compareprice = master[j].getAttribute("data-comapre-price");
      var choosen = true;
      available = master[j].getAttribute("data-available");
      sku = master[j].getAttribute("data-sku");
      document.querySelector(".product-sku span").textContent = sku;
      document.querySelector("#compare_at_price")
        ? document.querySelector("#compare_at_price").textContent = compareprice
        : "";
      document.querySelector("#price").textContent = price;
      var imges = master[j].getAttribute("data-image");

      document.querySelectorAll(".product-nav-img").forEach(function (img) {
        if (img.getAttribute("src") === imges) {
          img.click();
          // img.scrollIntoView();
        }
      });
    }
  }

  var availabletext = document.querySelector("#masterselect").getAttribute("data-available-text");
  var soldouttext = document.querySelector("#masterselect").getAttribute("data-solout-text");
  var unavailabletext = document.querySelector("#masterselect").getAttribute("data-unavailable-text");

  if (choosen) {
    if (available == "true") {
      document.querySelector(".latest-add-to-cart").textContent = availabletext;
      document.querySelector(".latest-add-to-cart").removeAttribute("disabled");
    }
    else if (available == "false") {
      document.querySelector(".latest-add-to-cart").textContent = soldouttext;
      document.querySelector(".latest-add-to-cart").setAttribute("disabled", "disabled");
    }
  }
  else {
    document.querySelector(".latest-add-to-cart").textContent = unavailabletext;
    document.querySelector(".latest-add-to-cart").setAttribute("disabled", "disabled")
  }

  var nextURL = window.location.pathname + "?variant=" + id;
  window.history.replaceState("", "", nextURL);
}

function updatecart(url) {
  fetch(url).then(function (response) {
    // The API call was successful!
    return response.text();
  }).then(function (html) {
    // Convert the HTML string into a document object
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    document.querySelector('.latest-cart').innerHTML = doc.querySelector(".latest-cart").innerHTML;
    document.querySelector(".cart_items_count").textContent = doc.querySelector(".cart_items_count").textContent;
  }).catch(function (err) {
    // There was an error
    console.warn('Something went wrong.', err);
  });
}

function updateinputcart(input) {
  var qty = input.value;
  url = input.getAttribute("data-url") + qty;
  updatecart(url)
}


document.querySelectorAll(".product-nav-img").forEach(function (img) {
  img.addEventListener("click", function () {
    this.parentElement.parentElement.querySelector(".active") ? this.parentElement.parentElement.querySelector(".active").classList.remove("active") : "";
    this.classList.add("active");
    if (this.getAttribute("data-type") == 'video') {
      document.querySelector(".product-image-container").classList.add("hideit");
      document.querySelectorAll(".product-video-container").forEach(function (video) {
        video.classList.add("hideit");
      })

      document.querySelector(".video-link-" + this.getAttribute("data-index")).classList.remove("hideit");
    }
    else {
      var mainimage = document.querySelector(".product-main-image");
      document.querySelector(".product-image-container").classList.remove("hideit");
      var src = this.getAttribute("src");
      mainimage.setAttribute("src", src);
      mainimage.setAttribute("data-izoomify-url", src);
      $('.target').izoomify();
    }
  });
});

document.querySelectorAll(".product-value").forEach(function (option) {
  option.addEventListener("click", function () {
    this.parentElement.querySelector(".active").classList.remove("active");
    this.classList.add("active");
    changemaster();
  });
});

document.querySelectorAll(".product_select").forEach(function (select) {
  select.addEventListener("change", function () {
    var val = this.value;
    console.log(this.parentElement.previousElementSibling.querySelectorAll(".product-value"));
    this.parentElement.previousElementSibling.querySelector(".active").classList.remove("active");
    this.parentElement.previousElementSibling.querySelectorAll(".product-value").forEach(function (opt) {
      if (opt.getAttribute("data-title") == val) {
        opt.classList.add("active");
        changemaster();
      }
    })
  });
});

if (document.querySelector(".product_qty svg:first-of-type")) {
  document.querySelector(".product_qty svg:first-of-type").addEventListener("click", function () {
    var qty = this.nextElementSibling.value;
    qty--;

    if (qty > 1) {
      this.nextElementSibling.value = qty;
    }
  });

  document.querySelector(".product_qty svg:last-of-type").addEventListener("click", function () {
    var qty = this.previousElementSibling.value;
    qty++;

    if (qty > 1) {
      this.previousElementSibling.value = qty;
    }
  });
}


// FIX: guard — read-more.min.js is deferred and may not be parsed yet on some pages
if (typeof $readMoreJS !== 'undefined') {
  $readMoreJS({
    // Selector of the element the plugin applies to (any CSS selector, eg: '#', '.').
    target: '.latest-rich-container',
    // Number of words to initially display (any number).
    wordsCount: 70,
    // If true, user can toggle between 'read more' and 'read less'.
    toggle: true,
    // The text of 'Read more' link.
    moreLink: 'Read more',
    // The text of 'Read less' link.
    lessLink: 'Read less',
    // The class given to the read more link.
    linkClass: 'latest-rich-container-link',
  });
}

if (document.querySelector(".latest-add-to-cart")) {
  document.querySelector(".latest-add-to-cart").addEventListener("click", function (e) {
    e.preventDefault();
    this.textContent = 'Adding ...';
    this.setAttribute("disabled", "disabled");
    var items = [];
    items.push({
      id: parseInt(document.querySelector("#masterselect").value),
      // quantity: parseInt(document.querySelector(".product_qty input").value)
      quantity: 1
    });

    // document.querySelectorAll(".addoncheckbox").forEach(function (add) {
    //   if (add.checked) {
    //     items.push({
    //       id: parseInt(add.getAttribute("data-id")),
    //       qunatity: 1
    //     })
    //   }
    // });

    // console.log(items)

    jQuery.post('/cart/add.js', {
      items: items
    }).done(function (data) {
      console.log(JSON.parse(data));
      var dataitems = JSON.parse(data)
      var image = dataitems.items[0].featured_image.url;
      var title = dataitems.items[0].title;
      document.querySelector(".ajax-product-image").setAttribute("src", image);
      document.querySelector(".ajax-product-title span").textContent = title;
    });

    setTimeout(() => {
      document.querySelector(".latest-add-to-cart").textContent = 'Added to cart';
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function (data) {
          $(".cart_items_count").text(data.item_count);
          setTimeout(() => {
            document.querySelector(".latest-add-to-cart").textContent = document.querySelector("#masterselect").getAttribute("data-available-text");
            document.querySelector(".latest-add-to-cart").removeAttribute("disabled");

            openajaxcart();
          }, 1000);

        },
        error: function (responseText) {
          console.log(responseText);
          setTimeout(() => {
            document.querySelector(".latest-add-to-cart").textContent = document.querySelector("#masterselect").getAttribute("data-available-text");
            document.querySelector(".latest-add-to-cart").removeAttribute("disabled");
          }, 1000);
        }
      });
    }, 1000);
  });
}

function accordion() {
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      panel.classList.toggle("panel_open");
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });

    if (acc[i].classList.contains("active")) {
      var panel = acc[i].nextElementSibling;
      panel.classList.toggle("panel_open");
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    }
  }
}

accordion();

if (document.querySelector(".showfiltertoggle")) {
  document.querySelector(".showfiltertoggle").addEventListener("click", function () {
    document.querySelector(".fitertabmobile").classList.add("openfilter");
  });

  document.querySelector(".closefiltermobile").addEventListener("click", function () {
    document.querySelector(".fitertabmobile").classList.remove("openfilter");
  });
}

// FIX: added `typeof Swiper !== 'undefined'` guard
if (typeof Swiper !== 'undefined' && document.querySelector(".latest-collection-categories")) {
  var rows = parseInt(document.querySelector(".latest-collection-categories").getAttribute("data-column"));
  var latest_collection_categories = new Swiper(".latest-collection-categories", {
    slidesPerView: rows,
    spaceBetween: 22,
    loop: true,
    pagination: {
      el: ".swiper-pagination", clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 22
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 22
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 22
      },
      1024: {
        slidesPerView: rows,
        spaceBetween: 22
      }
    }
  });
}


// FIX: this was the crash. Swiper is only loaded on index/product/collection in
// theme.liquid, so on /account/* etc this threw "Swiper is not defined" and
// killed every listener below it — including the search popup toggle.
var latest_announcement_bar_container_slider;
if (typeof Swiper !== 'undefined' && document.querySelector(".latest-announcement-bar-container-slider")) {
  latest_announcement_bar_container_slider = new Swiper(".latest-announcement-bar-container-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: true,
    loop: true
  });
}


document.querySelectorAll(".prev-slider").forEach(function (btn) {
  btn.addEventListener("click", function () {
    var prev = btn.parentElement.querySelector(".latest-collection-categories .swiper-button-prev");
    if (prev) prev.click();
  });
});

document.querySelectorAll(".next-slider").forEach(function (btn) {
  btn.addEventListener("click", function () {
    var next = btn.parentElement.querySelector(".latest-collection-categories .swiper-button-next");
    if (next) next.click();
  });
});

// Mobile menu functionality is now handled by Dawn's menu-drawer component (header-drawer)

function changesidebarmenu(faq) {
  faq.parentElement.querySelector(".active").classList.remove("active");
  faq.classList.add("active");
  var title = faq.getAttribute("data-title");
  document.querySelectorAll(".latest-faq-question-answer").forEach(function (l) {
    l.classList.remove("showfaq")
  })
  document.querySelectorAll(title).forEach(function (q) {
    q.classList.add("showfaq");
  })
  console.log(title);
}

if (document.querySelector("#SortBy") != null) {
  document.querySelector("#SortBy").addEventListener("change", function () {
    window.location.href = this.value;
  });
}

document.querySelectorAll(".latest_color").forEach(function (color) {
  color.addEventListener("click", function (e) {
    e.preventDefault();
    var img = this.getAttribute("data-image");
    var url = this.getAttribute("data-url");
    this.parentElement.querySelector(".active") ? this.parentElement.querySelector(".active").classList.remove("active") : "";
    this.classList.add("active");
    this.parentElement.parentElement.previousElementSibling.querySelector(".first-image").setAttribute("src", img);
    this.parentElement.parentElement.parentElement.parentElement.setAttribute("href", url);
  })
});

if (document.querySelector(".close_cms")) {
  document.querySelector(".close_cms").addEventListener("click", function () {
    document.querySelector(".product-warranty.deliverytime").style.display = 'none';
    document.querySelector(".product-warranty.deliverytime").nextElementSibling.classList.add("d-none");
  });
}


// FIX: added `typeof Swiper !== 'undefined'` + element guard
var swiper;
if (typeof Swiper !== 'undefined' && document.querySelector(".product-thumbnail-slider")) {
  swiper = new Swiper(".product-thumbnail-slider", {
    direction: "vertical",
    slidesPerView: 7,
    spaceBetween: 10,
    breakpoints: {
      0: {
        direction: "horizontal",
        slidesPerView: 5,
        spaceBetween: 10
      },
      640: {
        direction: "horizontal",
        slidesPerView: 5,
        spaceBetween: 10
      },
      750: {
        direction: "vertical",
        slidesPerView: 5,
        spaceBetween: 10
      }
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

document.querySelectorAll(".gotobelowdescription").forEach(function (des) {
  des.addEventListener("click", function (e) {
    e.preventDefault();
    document.getElementById('product-description').scrollIntoView();
  })
})

if (document.querySelector('.target')) {
  $(document).ready(function () {
    $('.target').izoomify();
  });
}

// FIX: guard
if (document.querySelector(".latest-search-input")) {
  document.querySelector(".latest-search-input").addEventListener("keyup", function () {
    this.parentElement.setAttribute("action", "/collections/shop");
  })
}

if (document.querySelector("main-search .search__input.field__input")) {
  document.querySelector("main-search .search__input.field__input").addEventListener("keyup", function () {
    this.parentElement.parentElement.setAttribute("action", "/collections/shop");
  })
}

// FIX: querySelectorAll instead of querySelector — the customer account template
// injects its own /search link, which was stealing the single-element match.
document.querySelectorAll("[href='/search']").forEach(function (searchLink) {
  searchLink.addEventListener("click", function (e) {
    var header = document.querySelector(".search-header");
    if (!header) return;
    e.preventDefault();
    header.classList.toggle("show");
    var input = header.querySelector(".latest-search-input");
    if (input && header.classList.contains("show")) input.focus();
  });
});

window.onload = function () {
  setTimeout(() => {
    if (document.querySelector("main-search .search__input.field__input")) {
      document.querySelector("main-search .search__input.field__input").parentElement.parentElement.setAttribute("action", "/collections/shop");
    }

    // FIX: guard
    if (document.querySelector(".latest-search-input")) {
      document.querySelector(".latest-search-input").parentElement.setAttribute("action", "/collections/shop");
    }
  }, 1000);
}

document.querySelectorAll(".second-level-d").forEach(function (second) {
  var length = second.querySelectorAll("li.second-level-li-d").length;
  second.querySelectorAll(".third-level-d").forEach(function (thirdlevel) {
    var lilength = thirdlevel.querySelectorAll("li").length;

    if (lilength >= length) {
      thirdlevel.style.height = 'max-content';
    }
  })
})



document.querySelectorAll(".latest-footer a[href^='http']").forEach(function (link) {
  if (!link.href.includes(location.hostname)) {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
  }
});
function fetchCart() {
  const wasOpen = document.querySelector('.cart-slider')?.classList.contains('open_cart');

  fetch('/?sections=cart-slider')
    .then(res => res.text())
    .then(data => {
      const json = JSON.parse(data);
      const parser = new DOMParser();
      const doc = parser.parseFromString(json['cart-slider'], 'text/html');

      const newCart = doc.getElementById('shopify-section-cart-slider');
      const currentCart = document.getElementById('shopify-section-cart-slider');

      if (newCart && currentCart) {
        if (wasOpen) {
          // drawer is already visible — keep it open through the swap, no animation
          newCart.querySelector('.cart-slider')?.classList.add('open_cart');
          newCart.querySelector('#overlay')?.classList.add('open_cart');
          currentCart.innerHTML = newCart.innerHTML;
        } else {
          // drawer is closed — strip, insert, force reflow, THEN animate open
          newCart.querySelector('.cart-slider')?.classList.remove('open_cart');
          newCart.querySelector('#overlay')?.classList.remove('open_cart');
          currentCart.innerHTML = newCart.innerHTML;

          const slider = document.querySelector('.cart-slider');
          if (slider) void slider.offsetWidth;

          requestAnimationFrame(openCart);
        }
      }

      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function (s) {
          document.querySelector(".cart_items_count").textContent = s.item_count;
        },
        error: function (responseText) {
          console.log(responseText);
        }
      });
    });
}
function openCart() {
  document.querySelector('.cart-slider')?.classList.add('open_cart');
  document.querySelector('#overlay')?.classList.add('open_cart');
}

function closecart() {
  document.querySelector('.cart-slider')?.classList.remove('open_cart');
  document.querySelector('#overlay')?.classList.remove('open_cart');
}

function drawerUpdatecart(line, quantity, loader) {
  if (loader) {
    document.querySelector(loader)?.style.setProperty('display', 'flex');
  }

  $.post('/cart/change.js', {
    line: Number(line),
    quantity: Number(quantity)
  }).done(fetchCart);
}

function add_product(id) {
  $.post('/cart/add.js', {
    items: [{ id: parseInt(id), quantity: 1 }]
  }).done(fetchCart);
}

function changeinput(line, inputSelector) {
  const qty = document.querySelector(inputSelector)?.value;
  if (qty) drawerUpdatecart(line, qty);
}


document.addEventListener('click', function (e) {

  // Open cart
  const cartLink = e.target.closest('[href^="/cart"], .cart-drawer-selector');
  if (cartLink) {
    e.preventDefault();
    fetchCart();
    return;
  }

  // Close cart
  if (e.target.id === 'overlay' || e.target.closest('.close-cart')) {
    closecart();
    return;
  }

  // Add to cart
  const addBtn = e.target.closest('[data-action="add-to-cart"]');
  if (addBtn) {
    e.preventDefault();
    const form = addBtn.closest('form');
    if (!form) return;

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $(form).serialize(),
      dataType: 'json',
      success: fetchCart
    });
  }
});